import NumberValueObject from "../../../shared/domain/value-object/number-value-object";

export default class AnimeDuration extends NumberValueObject {

}